
import "./App.css";
import "./global.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useState, lazy, Suspense } from "react";
import RequireAuth from "./requireAuth";
import { Spin } from "antd";
import "./loader.css";
import PortfolioLayout from "./Components/Portfolio Management/portfolioLayout";


const Approval = lazy(() => import("./Components/Approval"));
const Thankyou = lazy(() => import("./Components/Thankyou"));
const ApprovalGrouped = lazy(() => import("./Components/ApprovalGrouped"));
const ThankyouGrouped = lazy(() => import("./Components/ThankyouGrouped"));
// const Zeroda = lazy(()=> import("./Components/Zeroda/Zeroda"))

function App() {
  const [currentPage, setCurrentPage] = useState("login");

  // const renderPage = () => {
  //   switch (currentPage) {
  //     case "login":
  //       return <Login setCurrentPage={setCurrentPage} />;
  //     case "resetPassword":
  //       return <ForgotPassword setCurrentPage={setCurrentPage} />;
  //     case "verifyEmail":
  //       return <VerifyEmail setCurrentPage={setCurrentPage} />;
  //     case "setPassword":
  //       return <SetPassword setCurrentPage={setCurrentPage} />;
  //     default:
  //       return <Login setCurrentPage={setCurrentPage} />;
  //   }
  // };


  // Loader Component for Suspense
  const PageLoader = () => (
    <div className="page-loader">
      <Spin size="large" tip="Loading the page details... please wait" />
    </div>
  );


  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />} >
        <Routes>
          <Route path="/Approve" element={<Approval />} />
           <Route path="/thankyou" element={<Thankyou />} />
           <Route path="/ApproveGrouped" element={<ApprovalGrouped />} />
           <Route path="/thankyouGrouped" element={<ThankyouGrouped />} />
    
        </Routes>

      </Suspense>
    </BrowserRouter>
  );
}

export default App;


